import {useEffect, useLayoutEffect, useState} from "react";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import "./PwaInstallPrompt.scss"
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {css} from "@emotion/css";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import RaikoDefaultDialogPage, {DialogSize} from "../defaultDialogPage/RaikoDefaultDialogPage";
import installTheApp from "../../assets/images/header/10.svg"
import * as React from "react";
import ButtonSecondaryRaiko from "../../raikoComponents/raikoButtons/ButtonSecondaryRaiko";
import RaikoCheckbox from "../../raikoComponents/RaikoCheckbox/RaikoCheckbox";

export const PwaInstallPrompt = () => {

    const [showPrompt, setShowPrompt] = useState(false);
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())

    const [beforeInstallPrompt, setBeforeInstallPrompt] = useState(null);

    const [checked, setChecked] = useState(false);

    const [appNotInstalled, setAppNotInstalled] = useState(false);
    const [canShowPrompt, setCanShowPrompt] = useState("");

    useLayoutEffect(() => {
        const state = getPromptState()
        setCanShowPrompt(state)
    });


    useEffect(() => {
        console.log("can show is ", canShowPrompt)
        if (appNotInstalled && (!canShowPrompt || canShowPrompt === "false")) {
            setShowPrompt(true)
        }
    }, [appNotInstalled, canShowPrompt]);


    window.addEventListener("beforeinstallprompt", eventHandler, errorHandler);

    function eventHandler(event) {
        setBeforeInstallPrompt(event)
        setAppNotInstalled(true)
        // setShowPrompt(true)

    }

    function errorHandler(event) {
        snackbar.showErrorMessage("خطا در نصب برنامه !")
    }

    function installer() {
        if (beforeInstallPrompt) beforeInstallPrompt.prompt();
    }

    function handleCloseModal() {
        setShowPrompt(false)
    }


    const NOT_SHOW_PROMPT_MESSAGE_KEY = "SHOW_PROMPT_MESSAGE"

    function changePromptState(state) {
        window.sessionStorage.setItem(NOT_SHOW_PROMPT_MESSAGE_KEY, state)
    }

    function getPromptState() {
        return window.sessionStorage.getItem(NOT_SHOW_PROMPT_MESSAGE_KEY)
    }


    return (

        <section className={!showPrompt && css`display: none`}>

            <RaikoDefaultDialogPage
                onClose={handleCloseModal}
                open={showPrompt}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={"نصب پنل رایکو"}
            >
                <section className="dialogContent">
                    <img src={installTheApp} alt="install the app" width={200} height={200}/>
                    <span className={
                        css`color: var(--color-text);
                          font-size: var(--text-size-medium);
                          margin-top: 1rem;
                        `}>
                            نصب پنل رایکو
                        </span>

                    <span
                        className={css`color: var(--color-text);
                          margin-top: .5rem;`}>آیا می خواهید پنل رایکو را نصب کنید؟</span>
                    <div className={css`
                      width: 100%;
                      padding: .5rem 1rem 0 1rem;
                      display: flex;
                      gap: 0.5rem`}>
                        <ButtonPrimaryRaiko
                            className="w-100"
                            label={"نصب برنامه"}
                            onClick={e => {
                                console.log("try to install it ")
                                snackbar.showSuccessMessage("try ti install ...")
                                installer()
                            }}/>
                        <ButtonSecondaryRaiko
                            className="w-100"
                            label={"فعلا نه!"}
                            onClick={_ => {
                                if (checked) {
                                    changePromptState(true)
                                } else {
                                    changePromptState(false)
                                }
                                setShowPrompt(false)
                            }}
                        />
                    </div>
                    <RaikoCheckbox label={"لطفا دیگر این پیام رو نشان نده!"} checked={checked} setChecked={setChecked}/>
                </section>

            </RaikoDefaultDialogPage>
        </section>

    )
}